import { useDropsPageQuery } from "src/components/drops/DropsPage.generated";
import { DropsPageView } from "src/components/drops/DropsPageView";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useProjectContext } from "src/routes/projects/context/ProjectContext";
import { ProjectParams } from "src/routes/routesDef";

export function ProjectDropsPage() {
  const { projectId } = useRouteParams<ProjectParams>();
  const { name } = useProjectContext();
  const query = useDropsPageQuery({ variables: { filter: { project: [projectId] }, entityId: projectId } });

  return <DropsPageView query={query} documentTitleSuffix={name} />;
}
